import React from 'react'
import OEIInput from './OEIInput';
import './OEIPopover.css'
import OEIButton from './OEIButton';
import OEITextInput from './OEITextInput';
import { CleaningServices } from '@mui/icons-material';
import { CLIENT_NAME, EMPTY } from './Constants';

export default function NewAccountPopover(props) {

    const setClientName = (e) => {
        props.setNewData({ ...props.newData, clientName: e });
        props.setErrors({...props.errors,error1:EMPTY})
    }
    const setClientId = (e) => {
        props.setErrors({...props.errors,error2:EMPTY})
        props.setNewData({ ...props.newData, clientId: e.toLowerCase() });
    }
    const setDescription = (e) => {
        props.setErrors({...props.errors,error3:EMPTY})
        props.setNewData({ ...props.newData, description: e });
    }
     const setContactEmail = (e) => {
        props.setErrors({...props.errors,error4:EMPTY})
        props.setNewData({ ...props.newData, contactEmail: e });
    }
     const setOrganization = (e) => {
        props.setErrors({...props.errors,error5:EMPTY})
        props.setNewData({ ...props.newData, organization: e });
    }
      
    return (
        <>
        <OEIInput value={props.newData.clientName} newData={props.newData} setValue={setClientName} name={CLIENT_NAME} label='Account Name' errorMessage={props.errors.error1}showError='false'></OEIInput>
        <OEIInput value={props.newData.clientId} newData={props.newData} setValue={setClientId} name='clientId' label='API Client ID' errorMessage={props.errors.error2} ></OEIInput>
        <OEIInput value={props.newData.organization} newData={props.newData} setValue={setOrganization} name='organization' label='Organization' errorMessage={props.errors.error5} ></OEIInput>
        <OEIInput value={props.newData.contactEmail} newData={props.newData} setValue={setContactEmail} name='contactEmail' label='Contact Email' errorMessage={props.errors.error4} ></OEIInput> 
        <OEITextInput value={props.newData.description} newData={props.newData} setValue={setDescription} name='description' label='Description' errorMessage={props.errors.error3} ></OEITextInput>
        {props.generate?        ( <div style={{ display: 'flex', justifyContent: 'center',}} >
            <OEIButton labelName='Generate' onclick={()=>props.handleClickGenerate()}></OEIButton></div>):<div>
            <OEIInput copyIcon={true} value={props.newData.clientSecret} setNewData={props.setNewData} label='Secret Key' readOnly='true' defaultValue={EMPTY}></OEIInput>
            <OEIInput copyIcon={true}value={props.newData.integrationAccountId} newData={props.newData} setNewData={props.setNewData} label='Integrator ID' readOnly='true' defaultValue={EMPTY}></OEIInput>
            </div>
            }   
        </>
)
}
